import { Component, OnInit, ViewChild } from '@angular/core';
import { faInfoCircle, faCheck, faAngleRight, faAngleLeft, faAngleUp, faAngleDown, faCog } from '@fortawesome/free-solid-svg-icons';
import { ProjectService } from '../project.service';

import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from 'src/app/helper/shared/shared.service';
import { isNullOrUndefinedNumber, isNullOrEmpty, isNullOrUndefinedObject } from 'src/app/helper/validation';

import { HttpClient } from '@angular/common/http';
import { createPopper } from '@popperjs/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { UserInfoService } from '../../user-info/user-info.service'; //Modified by PP(2023-10-24): Check for timeout of logincode
import { Router } from '@angular/router'; //Modified by PP(2023-10-24): Check for timeout of logincode

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})

export class ReportsComponent implements OnInit {
  faCheck = faCheck;
  faAngleRight = faAngleRight;
  faAngleLeft = faAngleLeft;
  faInfoCircle = faInfoCircle;
  faAngleUp = faAngleUp;
  faAngleDown = faAngleDown;
  faCog = faCog;

  multiReport: any = [];
  childReport: any = [];
  reportSettings: any = [];
  selectedSolutionToChangeName: any = [];
  currentReportInfo: any = [];

  state = 6;
  showDropdown = false;
  //extractGraphSeriesValues = false;
  loading = false;
  rptlist = "";
  graphSeriesList = "";

  projectInfo;
  contamination;
  solutions;
  results;
  report;

  StandardRptInfo: any;
  ComparisonRptInfo: any;
  GraphSeriesRptInfo: any;
  AllRptInfo: any;

  UserIsAdmin = false; //Modified by PP(2022-09-21) : Follow CLD 2.0 : CLD 3.0 MVP1.0 - If record found in ownersetting, this user is an admin

  constructor(public projectService: ProjectService,
    public sharedService: SharedService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private httpService: HttpClient,
    private userInfoService: UserInfoService, //Modified by PP(2023-10-24): Check for timeout of logincode
    private router: Router //Modified by PP(2023-10-24): Check for timeout of logincode
  ) { }

  ngOnInit() {
    window.scroll(0, 0);

    this.projectInfo = this.projectService.projectdetails.projectInfo;
    this.contamination = this.projectService.projectdetails.contamination;
    this.solutions = this.projectService.projectdetails.solutions;
    this.results = this.projectService.projectdetails.results.data;
    //this.report = this.projectService.projectdetails.reportOptions;

    //Modified by Pinky Poh (2025-04-10) : Bug reported by Fabrice Morvan. Reported generated once then go solutions change a filter but report still captures old filter - START
    // if (this.projectService.projectdetails.reportOptions == undefined) {
    //   this.report = this.projectService.getReportOptionsEmptyValueStructure();
    //   this.projectService.projectdetails.reportOptions = this.report;
    // } else {
    //   this.report = this.projectService.projectdetails.reportOptions;
    // }
    this.report = this.projectService.getReportOptionsEmptyValueStructure();
    this.projectService.projectdetails.reportOptions = this.report;
    //Modified by Pinky Poh (2025-04-10) : Bug reported by Fabrice Morvan. Reported generated once then go solutions change a filter but report still captures old filter - END

    // this.reportSettings = {
    //   weightOfAdsorbant: false,
    //   contaminationInformation: false,
    //   filterSize: false,
    //   numberOfFilter: false,
    //   totalIndicativeWeight: false,
    //   frontVelocity: false,
    //   pressureDrop: false,
    //   contactTime: false,
    //   emailToMe: false
    // }

    //this.reportSettings = this.report.reportSettings;
    this.tickCorrectCheckBoxFromReportSettings();

    this.currentReportInfo.ReportInfoBySol = [];

    for (var x = 0; x < this.solutions.length; x++) {
      var newReportInfoBySol = this.projectService.getReportInfoBySolEmptyValueStructure();
      newReportInfoBySol.solutionID = this.solutions[x].solutionID;
      newReportInfoBySol.solutionName = this.solutions[x].solutionName;

      for (var y = 0; y < this.solutions[x].solutionDetails.length; y++) {
        var newReportInfoDetails = this.projectService.getReportInfoDetailsEmptyvalueStructure();
        newReportInfoDetails.combinationID = this.solutions[x].solutionDetails[y].combinationID;
        newReportInfoDetails.filterDBName = this.solutions[x].solutionDetails[y].filterDBName;
        newReportInfoDetails.filterName = this.solutions[x].solutionDetails[y].filterName;
        //newReportInfoDetails.mediaDBName = this.solutions[x].solutionDetails[y].combinationID;
        newReportInfoDetails.molecularGroup = this.solutions[x].solutionDetails[y].molecularGroup;
        newReportInfoDetails.molecularGroupID = this.solutions[x].solutionDetails[y].molecularGroupID;
        newReportInfoDetails.molecularID = this.solutions[x].solutionDetails[y].molecularID;
        newReportInfoDetails.molecularType = this.solutions[x].solutionDetails[y].molecularType;
        newReportInfoDetails.molecularTypeID = this.solutions[x].solutionDetails[y].molecularTypeID;
        newReportInfoBySol.solDetails.push(newReportInfoDetails);
      }

      //this.report.ReportInfoBySol.push(newReportInfoBySol);
      this.currentReportInfo.ReportInfoBySol.push(newReportInfoBySol);
    }
    this.UserIsAdmin = this.sharedService.listData.UserCanUseExcel; //Modified by PP(2022-09-21) : Follow CLD 2.0 : CLD 3.0 MVP1.0 - If record found in ownersetting, this user is an admin
  }

  ngAfterContentInit() {
    var abc = 123;
  }

  ngAfterViewInit() {
    this.setPoppers();
  }

  ngOnDestroy() {

  }

  onMouseClick(e: MouseEvent) {
    if (this.sharedService.clickOnMoreOptionsBtn) {
      var headerMenuClass: any;
      headerMenuClass = document.getElementsByClassName('topbar');
      for (var i = 0; i < headerMenuClass.length; i++) {
        if (headerMenuClass[i].style.zIndex == '-1') { //If User click again to remove the dropdown
          headerMenuClass[i].style.zIndex = '99';
        } else {
          headerMenuClass[i].style.zIndex = '-1';
        }
      }
    }
  }

  setPoppers() {
    let StandardRptInfoBtn = document.querySelector('#StandardRptInfoBtn');
    let StandardRptInfo = document.getElementById('divStandardRptInfo');

    let ComparisonRptInfoBtn = document.querySelector('#ComparisonRptInfoBtn');
    let ComparisonRptInfo = document.getElementById('divComparisonRptInfo');

    let GraphSeriesRptInfoBtn = document.querySelector('#GraphSeriesRptInfoBtn');
    let GraphSeriesRptInfo = document.getElementById('divGraphSeriesRptInfo');

    let AllRptInfoBtn = document.querySelector('#AllRptInfoBtn');
    let AllRptInfo = document.getElementById('divAllRptInfo');

    this.createPop(StandardRptInfoBtn, StandardRptInfo);
    this.createPop(ComparisonRptInfoBtn, ComparisonRptInfo);
    this.createPop(GraphSeriesRptInfoBtn, GraphSeriesRptInfo);
    this.createPop(AllRptInfoBtn, AllRptInfo);
  }

  createPop(ref, popper) {
    createPopper(ref, popper, {
      placement: "top-start",
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 8],
          },
        },
        {
          name: "flip",
          options: {
            flipVariations: false,
            fallbackPlacements: ["top-start"],
          },
        },
      ],
    });
  }

  showHideInfoToggle(event) {
    let StandardRptInfo = document.getElementById('divStandardRptInfo');
    let ComparisonRptInfo = document.getElementById('divComparisonRptInfo');
    let GraphSeriesRptInfo = document.getElementById('divGraphSeriesRptInfo');
    let AllRptInfo = document.getElementById('divAllRptInfo');

    if (!this.StandardRptInfo && event === 'StandardRptInfo') {
      StandardRptInfo.setAttribute('data-show', '');
      this.StandardRptInfo = true;
    } else if (this.StandardRptInfo && event === 'StandardRptInfo') {
      StandardRptInfo.removeAttribute('data-show');
      this.StandardRptInfo = false;
    }

    if (!this.ComparisonRptInfo && event === 'ComparisonRptInfo') {
      ComparisonRptInfo.setAttribute('data-show', '');
      this.ComparisonRptInfo = true;
    } else if (this.ComparisonRptInfo && event === 'ComparisonRptInfo') {
      ComparisonRptInfo.removeAttribute('data-show');
      this.ComparisonRptInfo = false;
    }

    if (!this.GraphSeriesRptInfo && event === 'GraphSeriesRptInfo') {
      GraphSeriesRptInfo.setAttribute('data-show', '');
      this.GraphSeriesRptInfo = true;
    } else if (this.GraphSeriesRptInfo && event === 'GraphSeriesRptInfo') {
      GraphSeriesRptInfo.removeAttribute('data-show');
      this.GraphSeriesRptInfo = false;
    }

    if (!this.AllRptInfo && event === 'AllRptInfo') {
      AllRptInfo.setAttribute('data-show', '');
      this.AllRptInfo = true;
    } else if (this.AllRptInfo && event === 'AllRptInfo') {
      AllRptInfo.removeAttribute('data-show');
      this.AllRptInfo = false;
    }
  }

  setState(data) {
    this.state = data;
    if (data === 6) { //All of the Above
      if (this.multiReport.indexOf(data) > -1) {
        this.multiReport = [];
        for (var x = 1; x < 3; x++) {
          this.state = x;
        }
      } else {
        this.multiReport = [];
        this.multiReport.push(data);
        for (var x = 1; x < 3; x++) {
          this.state = x;
          this.multiReport.push(x);
        }
      }

      // Child Report
      if (this.childReport != undefined) {
        if (this.childReport.indexOf(data) > -1) {
          this.childReport = [];
          for (var x = 1; x < 1; x++) {
            this.state = x;
          }
          //this.extractGraphSeriesValues = false; 
        } else {
          if (this.UserIsAdmin) {
            this.childReport = [];
            this.childReport.push(data);
            for (var x = 0; x < this.solutions.length; x++) {
              this.state = x;
              this.childReport.push(x);
            }
          }
        }
      } else {
        if (this.UserIsAdmin) {
          this.childReport = [];
          for (var x = 0; x < this.solutions.length; x++) {
            this.state = x;
            this.childReport.push(x);
          }
        }
      }
      this.showDropdown = true;
    } else {
      if (this.multiReport.indexOf(data) > -1) {
        this.multiReport.splice(this.multiReport.indexOf(data), 1);
      } else {
        this.multiReport.push(data);
      }
    }
  }

  setChildState(data) {
    if (this.childReport.indexOf(data) > -1) {
      this.childReport.splice(this.childReport.indexOf(data), 1);
    } else {
      this.childReport.push(data);
    }
  }

  setChangeMediaInfoState(pIndex) {
    if (this.selectedSolutionToChangeName.indexOf(pIndex) > -1) {
      this.selectedSolutionToChangeName.splice(this.childReport.indexOf(pIndex), 1);
    } else {
      this.selectedSolutionToChangeName.push(pIndex);
    }

    var ShowChangeMediaNameDiv: any;
    ShowChangeMediaNameDiv = document.getElementById('divChangeMedianameForSol' + pIndex);
    if (ShowChangeMediaNameDiv != null || ShowChangeMediaNameDiv != undefined) {
      ShowChangeMediaNameDiv.style.display = 'block';
    }
  }

  toggleDrop() {
    if (this.showDropdown) {
      this.showDropdown = false;
    } else {
      this.showDropdown = true;
    }
  }

  triggerDoneFromRptSettings() {
    //Put all the settings into projectDetails
    switch (this.reportSettings.weightOfAdsorbant) {
      case true:
        this.projectService.projectdetails.reportOptions.reportSettings.weightOfAdsorbant = true;
        break;
      case false:
        this.projectService.projectdetails.reportOptions.reportSettings.weightOfAdsorbant = false;
        break;
    }

    switch (this.reportSettings.contaminationInformation) {
      case true:
        this.projectService.projectdetails.reportOptions.reportSettings.contaminationInformation = true;
        break;
      case false:
        this.projectService.projectdetails.reportOptions.reportSettings.contaminationInformation = false;
        break;
    }

    switch (this.reportSettings.filterSize) {
      case true:
        this.projectService.projectdetails.reportOptions.reportSettings.filterSize = true;
        break;
      case false:
        this.projectService.projectdetails.reportOptions.reportSettings.filterSize = false;
        break;
    }

    switch (this.reportSettings.numberOfFilter) {
      case true:
        this.projectService.projectdetails.reportOptions.reportSettings.numberOfFilter = true;
        break;
      case false:
        this.projectService.projectdetails.reportOptions.reportSettings.numberOfFilter = false;
        break;
    }

    switch (this.reportSettings.emailToMe) {
      case true:
        this.projectService.projectdetails.reportOptions.reportSettings.emailToMe = true;
        break;
      case false:
        this.projectService.projectdetails.reportOptions.reportSettings.emailToMe = false;
        break;
    }

    switch (this.reportSettings.totalIndicativeWeight) {
      case true:
        this.projectService.projectdetails.reportOptions.reportSettings.totalIndicativeWeight = true;
        break;
      case false:
        this.projectService.projectdetails.reportOptions.reportSettings.totalIndicativeWeight = false;
        break;
    }

    switch (this.reportSettings.frontVelocity) {
      case true:
        this.projectService.projectdetails.reportOptions.reportSettings.frontVelocity = true;
        break;
      case false:
        this.projectService.projectdetails.reportOptions.reportSettings.frontVelocity = false;
        break;
    }

    switch (this.reportSettings.pressureDrop) {
      case true:
        this.projectService.projectdetails.reportOptions.reportSettings.pressureDrop = true;
        break;
      case false:
        this.projectService.projectdetails.reportOptions.reportSettings.pressureDrop = false;
        break;
    }

    switch (this.reportSettings.contactTime) {
      case true:
        this.projectService.projectdetails.reportOptions.reportSettings.contactTime = true;
        break;
      case false:
        this.projectService.projectdetails.reportOptions.reportSettings.contactTime = false;
        break;
    }

    //Put all the new media name changes into projectDetails
    this.projectService.projectdetails.reportOptions.ReportInfoBySol = [];
    for (var x = 0; x < this.currentReportInfo.ReportInfoBySol.length; x++) {
      var newReportInfoBySol = this.projectService.getReportInfoBySolEmptyValueStructure();
      newReportInfoBySol.solutionID = this.currentReportInfo.ReportInfoBySol[x].solutionID;
      newReportInfoBySol.solutionName = this.currentReportInfo.ReportInfoBySol[x].solutionName;

      for (var y = 0; y < this.currentReportInfo.ReportInfoBySol[x].solDetails.length; y++) {
        var newReportInfoDetails = this.projectService.getReportInfoDetailsEmptyvalueStructure();
        newReportInfoDetails.combinationID = this.currentReportInfo.ReportInfoBySol[x].solDetails[y].combinationID;
        newReportInfoDetails.filterDBName = this.currentReportInfo.ReportInfoBySol[x].solDetails[y].filterDBName;
        newReportInfoDetails.filterName = this.currentReportInfo.ReportInfoBySol[x].solDetails[y].filterName;
        //newReportInfoDetails.mediaDBName = this.currentReportInfo.ReportInfoBySol[x].solDetails[y].combinationID;
        newReportInfoDetails.molecularGroup = this.currentReportInfo.ReportInfoBySol[x].solDetails[y].molecularGroup;
        newReportInfoDetails.molecularGroupID = this.currentReportInfo.ReportInfoBySol[x].solDetails[y].molecularGroupID;
        newReportInfoDetails.molecularID = this.currentReportInfo.ReportInfoBySol[x].solDetails[y].molecularID;
        newReportInfoDetails.molecularType = this.currentReportInfo.ReportInfoBySol[x].solDetails[y].molecularType;
        newReportInfoDetails.molecularTypeID = this.currentReportInfo.ReportInfoBySol[x].solDetails[y].molecularTypeID;
        newReportInfoDetails.newFilterGroup = this.currentReportInfo.ReportInfoBySol[x].solDetails[y].newFilterGroup;
        newReportInfoDetails.newFilterType = this.currentReportInfo.ReportInfoBySol[x].solDetails[y].newFilterType;
        newReportInfoDetails.newMedia = this.currentReportInfo.ReportInfoBySol[x].solDetails[y].newMedia;
        newReportInfoBySol.solDetails.push(newReportInfoDetails);
      }
      this.projectService.projectdetails.reportOptions.ReportInfoBySol.push(newReportInfoBySol);
    }
  }

  triggerCancelFromRptSettings() {
    this.tickCorrectCheckBoxFromProjectDetails();

    if (this.sharedService.checkUncheckLabel === 'Check all') {
      this.sharedService.checkUncheckLabel = 'Uncheck all';
    }

    if (this.sharedService.checkUncheckLabel === 'Uncheck all') {
      this.sharedService.checkUncheckLabel = 'Check all';
    }

    for (var x = 0; x < this.currentReportInfo.ReportInfoBySol.length; x++) {
      for (var y = 0; y < this.currentReportInfo.ReportInfoBySol[x].solDetails.length; y++) {
        this.currentReportInfo.ReportInfoBySol[x].solDetails[y].newFilterGroup = '';
        this.currentReportInfo.ReportInfoBySol[x].solDetails[y].newFilterType = '';
        this.currentReportInfo.ReportInfoBySol[x].solDetails[y].newMedia = '';
      }
    }
  }

  onCheckBoxChange(pEvent: any) {
    switch (pEvent.currentTarget.id) {
      case "chkWeightOfAdsorbant":
        this.reportSettings.weightOfAdsorbant = pEvent.currentTarget.checked;
        break;

      case "chkContaminationInfo":
        this.reportSettings.contaminationInformation = pEvent.currentTarget.checked;
        break;

      case "chkFilterSize":
        this.reportSettings.filterSize = pEvent.currentTarget.checked;
        break;

      case "chkNumberOfFilter":
        this.reportSettings.numberOfFilter = pEvent.currentTarget.checked;
        break;

      case "chkTotIndicativeWeight":
        this.reportSettings.totalIndicativeWeight = pEvent.currentTarget.checked;
        break;

      case "chkFrontVelocity":
        this.reportSettings.frontVelocity = pEvent.currentTarget.checked;
        break;

      case "chkPressureDrop":
        this.reportSettings.pressureDrop = pEvent.currentTarget.checked;
        break;

      case "chkContactTime":
        this.reportSettings.contactTime = pEvent.currentTarget.checked;
        break;

      case "chkEmailToMe":
        //this.reportSettings.emailToMe = pEvent.currentTarget.checked;
        break;
    }
  }

  prepareRptList() {
    this.loading = true;
    this.rptlist = "";
    this.graphSeriesList = "";

    // From Multi Report Array
    if (!isNullOrUndefinedNumber(this.multiReport)) {
      for (var x = 0; x < this.multiReport.length; x++) {
        var RptName = "";
        switch (this.multiReport[x]) {
          case 1:
            RptName = "Standard Solution Report";
            break;
          case 2:
            RptName = "Comparison Report";
            break;
        }
        if (this.rptlist === "") {
          this.rptlist = RptName;
        } else {
          this.rptlist = this.rptlist + ";" + RptName;
        }
      } //for(var x=0;x<this.multiReport.length;x++)
    }

    // From Child Report Array (Graph Series)
    if (!isNullOrUndefinedNumber(this.childReport) && this.childReport.length > 0) {
      if (this.rptlist === "") {
        this.rptlist = "Graph Series";
      } else {
        this.rptlist = this.rptlist + ";" + "Graph Series";
      }

      for (var x = 0; x < this.childReport.length; x++) {
        var RptName = "";
        if (this.childReport[x] != 6) {
          RptName = this.solutions[this.childReport[x]].solutionID;
        }

        if (RptName != "") {
          if (this.graphSeriesList === "") {
            this.graphSeriesList = RptName;
          } else {
            this.graphSeriesList = this.graphSeriesList + ";" + RptName;
          }
        }
      } //for(var x=0;x<this.childReport.length;x++)
    }

    //Modified by Pinky (2026-07-08) : Fix issues to cater for upgrade to .net10 if (this.report.ReportInfoBySol.length == 0) {
    if (this.report.ReportInfoBySol.length == 0 || this.report == undefined) { //Modified by Pinky (2026-07-08) : Fix issues to cater for upgrade to .net10
      this.report.ReportInfoBySol = this.currentReportInfo.ReportInfoBySol;
    }

    if (this.rptlist != '') {
      this.projectService.projectdetails.reportOptions.reportsToGenerate = this.rptlist;
      this.projectService.projectdetails.reportOptions.graphSeriesToGenerate = this.graphSeriesList;
      this.startCompileDataForReports();
    } else {
      this.loading = false;
      this.toastr.error("No reports selected. Please try again.", "");
    }

  }

  startCompileDataForReports() {
    this.sharedService.ServerData = this.sharedService.CompileDataForCalculation(this.projectService.projectdetails, 0); //0 = for all
    this.sharedService.CountTotalSeqForUploadingParams(this.sharedService.ServerData, "UPLOAD MCCLD PARAMS TO SERVER");
    this.PrepareToUploadParams();
  }

  PrepareToUploadParams() {
    var dataToUpload = this.sharedService.generateStr();
    console.log("PS20230321 Check: => UploadServerData2TempStringStorage - START=> " + new Date());
    this.projectService.UploadServerData2TempStringStorage(dataToUpload).subscribe(res => {
      console.log("PS20230321 Check: => UploadServerData2TempStringStorage - END=> " + new Date());
      if (res) {
        this.sharedService.TempStringStorageTotalPass = this.sharedService.TempStringStorageTotalPass + 1;
        this.sharedService.ServerDataReady = true;
        this.sharedService.UploadingEntry = false;
        if (this.sharedService.TempStringStorageTotalPass + this.sharedService.TempStringStorageTotalFail !== this.sharedService.TempStringStorageTotalSeq) {
          this.sharedService.TempStringStorageCurrentSeq = this.sharedService.TempStringStorageCurrentSeq + 1;
          this.PrepareToUploadParams();
        } else {
          if (this.sharedService.TempStringStorageTotalPass === this.sharedService.TempStringStorageTotalSeq) {
            console.log("PS20230321 Check: => Generate CLD report -START=> " + new Date());
            this.projectService.generateReport().subscribe(async data => {
              console.log("PS20230321 Check: => Generate CLD report -END=> " + new Date());

              //Modified by PP(2023-10-24): Check for timeout of logincode - START
              // if (data) {
              //   window.open(data);
              //   this.loading = false;
              // } else {
              //   this.toastr.error("Unable to generate report. Please try again.", "");
              // }

              //pplim 20250711
              console.log('ppdebug: ' + JSON.stringify(data));
              //...Output/PDF/Ext-PangPengLim/202507112146221948/asd.zip

              if (data !== null) {
                if (data !== undefined) {
                  //pplim 20250924: bloburl
                  //window.open(data);
                  if (data && data.FilePath && data.FileName) {

                    this.userInfoService.updateUserApplicationUsage(this.sharedService.token, 'GENERATE_REPORTS').subscribe(result => {                       
                      if (result) {}
                    });

                    try {
                      const blob = await this.sharedService.downloadFile(data.FilePath);
                      const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/octet-stream' }));
                      const link = document.createElement('a');
                      link.href = url;
                      link.setAttribute('download', data.FileName);
                      document.body.appendChild(link);
                      link.click();
                      link.remove();
                    } catch (error) {
                      this.toastr.error('Error downloading report')
                      console.error('Error downloading report', error);
                    } finally {
                      this.toastr.success('MCCLD report : Successfully generate report.')
                    }
                  } else {
                    this.toastr.error('Failed to generate report.')
                  }

                  this.loading = false;
                } else {
                  this.toastr.error("Unable to generate report. Please try again.", "");
                }
              } else {
                this.sharedService.redirectToLoginPage();
                // this.userInfoService.userData.UserId = 0;
                // this.toastr.error('Session time out. Please login again.', '');
                // this.router.navigate(["login"]);
              }
              //Modified by PP(2023-10-24): Check for timeout of logincode - END
            });
          } else { //if (this.sharedService.TempStringStorageTotalPass===this.sharedService.TempStringStorageTotalSeq)
            this.loading = false;
            this.toastr.error("Failed to upload Parameters for Calculation." + " TotalPass <> TotalSeq.", "");
          }
        }
      } else { //if (res)
        this.loading = false;
        this.sharedService.TempStringStorageTotalFail = this.sharedService.TempStringStorageTotalFail + 1;
        this.sharedService.UploadingEntry = false;
        this.sharedService.ServerDataReady = false;
        this.toastr.error("Failed to upload Parameters for Calculation." + " TotalFail>1.", "");
      }
    }, err => {
      this.loading = false;
      this.toastr.error("Failed to upload Parameters. Please try again.", "");
    });
  }

  tickCorrectCheckBoxFromReportSettings() {
    switch (this.reportSettings.weightOfAdsorbant) {
      case true:
        (<HTMLInputElement>document.getElementById('chkWeightOfAdsorbant')).checked = true;
        break;
      case false:
        (<HTMLInputElement>document.getElementById('chkWeightOfAdsorbant')).checked = false;
        break;
    }

    switch (this.reportSettings.contaminationInformation) {
      case true:
        (<HTMLInputElement>document.getElementById('chkContaminationInfo')).checked = true;
        break;
      case false:
        (<HTMLInputElement>document.getElementById('chkContaminationInfo')).checked = false;
        break;
    }

    switch (this.reportSettings.filterSize) {
      case true:
        (<HTMLInputElement>document.getElementById('chkFilterSize')).checked = true;
        break;
      case false:
        (<HTMLInputElement>document.getElementById('chkFilterSize')).checked = false;
        break;
    }

    switch (this.reportSettings.numberOfFilter) {
      case true:
        (<HTMLInputElement>document.getElementById('chkNumberOfFilter')).checked = true;
        break;
      case false:
        (<HTMLInputElement>document.getElementById('chkNumberOfFilter')).checked = false;
        break;
    }

    switch (this.reportSettings.emailToMe) {
      case true:
        //(<HTMLInputElement>document.getElementById('chkEmailToMe')).checked = true;
        break;
      case false:
        //(<HTMLInputElement>document.getElementById('chkEmailToMe')).checked = false;
        break;
    }

    switch (this.reportSettings.totalIndicativeWeight) {
      case true:
        (<HTMLInputElement>document.getElementById('chkTotIndicativeWeight')).checked = true;
        break;
      case false:
        (<HTMLInputElement>document.getElementById('chkTotIndicativeWeight')).checked = false;
        break;
    }

    switch (this.reportSettings.frontVelocity) {
      case true:
        (<HTMLInputElement>document.getElementById('chkFrontVelocity')).checked = true;
        break;
      case false:
        (<HTMLInputElement>document.getElementById('chkFrontVelocity')).checked = false;
        break;
    }

    switch (this.reportSettings.pressureDrop) {
      case true:
        (<HTMLInputElement>document.getElementById('chkPressureDrop')).checked = true;
        break;
      case false:
        (<HTMLInputElement>document.getElementById('chkPressureDrop')).checked = false;
        break;
    }

    switch (this.reportSettings.contactTime) {
      case true:
        (<HTMLInputElement>document.getElementById('chkContactTime')).checked = true;
        break;
      case false:
        (<HTMLInputElement>document.getElementById('chkContactTime')).checked = false;
        break;
    }
  }

  tickCorrectCheckBoxFromProjectDetails() {
    switch (this.projectService.projectdetails.reportOptions.reportSettings.weightOfAdsorbant) {
      case true:
        this.reportSettings.weightOfAdsorbant = true;
        (<HTMLInputElement>document.getElementById('chkWeightOfAdsorbant')).checked = true;
        break;

      case false:
        this.reportSettings.weightOfAdsorbant = false;
        (<HTMLInputElement>document.getElementById('chkWeightOfAdsorbant')).checked = false;
        break;
    }

    switch (this.projectService.projectdetails.reportOptions.reportSettings.contaminationInformation) {
      case true:
        this.reportSettings.contaminationInformation = true;
        (<HTMLInputElement>document.getElementById('chkContaminationInfo')).checked = true;
        break;
      case false:
        this.reportSettings.contaminationInformation = false;
        (<HTMLInputElement>document.getElementById('chkContaminationInfo')).checked = false;
        break;
    }

    switch (this.projectService.projectdetails.reportOptions.reportSettings.filterSize) {
      case true:
        this.reportSettings.filterSize = true;
        (<HTMLInputElement>document.getElementById('chkFilterSize')).checked = true;
        break;
      case false:
        this.reportSettings.filterSize = false;
        (<HTMLInputElement>document.getElementById('chkFilterSize')).checked = false;
        break;
    }

    switch (this.projectService.projectdetails.reportOptions.reportSettings.numberOfFilter) {
      case true:
        this.reportSettings.numberOfFilter = true;
        (<HTMLInputElement>document.getElementById('chkNumberOfFilter')).checked = true;
        break;

      case false:
        this.reportSettings.numberOfFilter = false;
        (<HTMLInputElement>document.getElementById('chkNumberOfFilter')).checked = false;
        break;
    }

    switch (this.projectService.projectdetails.reportOptions.reportSettings.emailToMe) {
      case true:
        this.reportSettings.emailToMe = true;
        //(<HTMLInputElement>document.getElementById('chkEmailToMe')).checked = true;
        break;

      case false:
        this.reportSettings.emailToMe = false;
        //(<HTMLInputElement>document.getElementById('chkEmailToMe')).checked = false;
        break;
    }

    switch (this.projectService.projectdetails.reportOptions.reportSettings.totalIndicativeWeight) {
      case true:
        this.reportSettings.totalIndicativeWeight = true;
        (<HTMLInputElement>document.getElementById('chkTotIndicativeWeight')).checked = true;
        break;

      case false:
        this.reportSettings.totalIndicativeWeight = false;
        (<HTMLInputElement>document.getElementById('chkTotIndicativeWeight')).checked = false;
        break;
    }

    switch (this.projectService.projectdetails.reportOptions.reportSettings.frontVelocity) {
      case true:
        this.reportSettings.frontVelocity = true;
        (<HTMLInputElement>document.getElementById('chkFrontVelocity')).checked = true;
        break;

      case false:
        this.reportSettings.frontVelocity = false;
        (<HTMLInputElement>document.getElementById('chkFrontVelocity')).checked = false;
        break;
    }

    switch (this.projectService.projectdetails.reportOptions.reportSettings.pressureDrop) {
      case true:
        this.reportSettings.pressureDrop = true;
        (<HTMLInputElement>document.getElementById('chkPressureDrop')).checked = true;
        break;

      case false:
        this.reportSettings.pressureDrop = false;
        (<HTMLInputElement>document.getElementById('chkPressureDrop')).checked = false;
        break;
    }

    switch (this.projectService.projectdetails.reportOptions.reportSettings.contactTime) {
      case true:
        this.reportSettings.contactTime = true;
        (<HTMLInputElement>document.getElementById('chkContactTime')).checked = true;
        break;

      case false:
        this.reportSettings.contactTime = false;
        (<HTMLInputElement>document.getElementById('chkContactTime')).checked = false;
        break;
    }
  }

  triggerCheckAllButton() {
    if (this.sharedService.checkUncheckLabel === 'Check all') {
      this.reportSettings = {
        weightOfAdsorbant: true,
        contaminationInformation: true,
        filterSize: true,
        numberOfFilter: true,
        totalIndicativeWeight: true,
        frontVelocity: true,
        pressureDrop: true,
        contactTime: true,
        //emailToMe: true
      }
      this.sharedService.checkUncheckLabel = 'Uncheck all';
      this.tickCorrectCheckBoxFromReportSettings();
      return;
    }

    if (this.sharedService.checkUncheckLabel === 'Uncheck all') {
      this.reportSettings = {
        weightOfAdsorbant: false,
        contaminationInformation: false,
        filterSize: false,
        numberOfFilter: false,
        totalIndicativeWeight: false,
        frontVelocity: false,
        pressureDrop: false,
        contactTime: false,
        //emailToMe: true
      }
      this.sharedService.checkUncheckLabel = 'Check all';
      this.tickCorrectCheckBoxFromReportSettings();
    }
  }

}